import angular from 'angular'

import States from './states'
import InvitationHandlersRepository from './invitation-handlers.repo';

export default angular.module('rb.invitations', [ ])
  .config(States)
  .service('InvitationHandlersRepository', InvitationHandlersRepository)
